export default __webpack_public_path__ + "static/card-back-1-bf611636516bd76b0ca397a5b2dd24ad.png";